export function cleanAndFormatText(text) {
  if (!text) return '';
  if (typeof text === 'object') {
    text = JSON.stringify(text, null, 2);
  }
  return text.toString();
}

export function formatText(text, prompt = '') {
  if (!text) return '';
  text = cleanAndFormatText(text);
  
  const explicitlyRequestsBulletPoints = 
    prompt.toLowerCase().includes("bullet point") || 
    prompt.toLowerCase().includes("bullet-point") || 
    prompt.toLowerCase().includes("bulletpoint");
  
  let formatted = text
    .replace(/```[a-z]*|```/g, '')
    .replace(/^\s*###\s*/gm, '')
    .replace(/^\s*####\s*/gm, '')
    .replace(/\*\*\*(.*?)\*\*\*/g, '<strong style="color: #dc2626; font-weight: 700;">$1</strong>')
    .replace(/\*\*!(.*?)!\*\*/g, '<strong style="color: #dc2626; font-weight: 700;">$1</strong>')
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

  if (explicitlyRequestsBulletPoints) {
    const hasBulletPoints = /^\s*[-•*]\s+|^\s*\d+\.\s+/gm.test(text);
    if (hasBulletPoints) {
      formatted = formatted
        .replace(/^\s*[-•]\s*(.*?)(?=\n|$)/gm, '___BULLET_START___$1___BULLET_END___')
        .replace(/^\s*\*\s*(.*?)(?=\n|$)/gm, '___BULLET_START___$1___BULLET_END___')
        .replace(/^\s*\d+\.\s*(.*?)(?=\n|$)/gm, '___BULLET_START___$1___BULLET_END___');
      
      let bulletCount = 0;
      formatted = formatted.replace(/___BULLET_START___(.*?)___BULLET_END___/g, (match, content) => {
        bulletCount++;
        return `<div class="flex items-center gap-1 border border-gray-200 rounded-lg p-2 transition-all hover:border-gray-300 hover:translate-y-[-2px] hover:shadow-sm mt-1"><div><span class="bg-primary text-white px-1.5 py-0.5 rounded-full m-1 text-xs">${bulletCount}</span></div> <div>${content}</div></div>`;
      });
    }
  }

  formatted = formatted
    .replace(/\n/g, '<br>')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/<br><br>/g, '<br><br>')
    .replace(/(•\s*<br>\s*){2,}/g, '<br>')
    .replace(/•\s*([^<\s])/g, '• $1');

  return formatted;
}